import React, { ChangeEvent, useRef, useState } from "react";

import DayOfBirth from "@pages/SIO/BasicDetails/components/DayOfBirth/DayOfBirth";
import Modal from "@components/Modal";
import Dropdown from "@components/Dropdown";
import Bullet from "@components/Bullet";
import Button from "@components/Button";
import Input from "@components/_Revamp/Input";
import Heading from "@components/Heading";
import RadioButtonGroup from "@components/RadioButtonGroup";
import RadioButton from "@components/RadioButton";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { Helpers, Validations } from "@utils/helpers";
import { styled } from "@linaria/react";
import { useHistory } from "react-router-dom";
import { ROUTE_PATH } from "@static/route-paths";
import { postManualSingpass } from "@api/index";
import { defaultSingpassManualDataPayload } from "@static/singpass-default-payload";
import {
  updatePersonalInfo,
  updatePersonalChildInfo,
  updateReadyToGoNext,
  updateTransactionId,
} from "@redux/slices/SHIELD_STARTER/step3Slice";
import { SHIELD_STARTER_HELTH_PLUS } from "@static/staticConstents";

const Labels = styled.div`
  font-size: 16px;
  margin: 0 0 5px;
  marigin-top: 20px;
`;
const childCountDropDown = [
  { code: 1, description: 1 },
  { code: 2, description: 2 },
  { code: 3, description: 3 },
  { code: 4, description: 4 },
  { code: 5, description: 5 },
];
const defaultData = JSON.parse(
  JSON.stringify(defaultSingpassManualDataPayload)
);
defaultData.person.childrenbirthrecords = [];
export default function SinpassManualDataWithValidation({
  isShowModal,
  setIsHowModal,
}: {
  isShowModal: boolean;
  setIsHowModal: Function;
}) {
  const history = useHistory();
  const topreference = useRef<HTMLDivElement>(null);
  const dispatch = useAvivaDispatch();
  const [globalErrorMsg, setGlobalErrorMsg] = useState(false);
  const transactionId = useAvivaSelector(state=>state.mltcR3Step2.transactionId)
  
  const selectedPolicy = useAvivaSelector(
    (state) => state.shieldStarterStep2.policyName
  );
  const whomToBuy = useAvivaSelector(
    (state) => state.shieldStarterStep1.whomToBuy
  );

  const isChild = whomToBuy === "child" ? true : false;
  const [profileData, setProfileData] = useState(defaultData);
  function updateChild(e: React.ChangeEvent<HTMLInputElement>) {
    const childDefault: any =
      defaultSingpassManualDataPayload.person.childrenbirthrecords[0];
    const data = Array<any>(+e.target.value).fill(childDefault);
    setProfileData((prev: any) => {
      const state = { ...prev };
      state.person.childrenbirthrecords = JSON.parse(JSON.stringify(data));
      return state;
    });
  }
  function validationObj(obj: any, isChild: boolean | undefined) {
    function isValidDayOfBirth(dob: string) {
      if (!dob.split("-").every((x) => x)) return false;
      const currentDob = new Date(dob);
      const today = new Date();
      return currentDob < today;
    }
    const checkNric = !isChild ? obj.uinfin.value : obj.birthcertno;
    const address =
      !isChild &&
      obj.regadd.block.value &&
      Validations.isValidPostalCode(obj.regadd.postal.value) &&
      obj.regadd.street.value;
    //  &&
    // Validations.isValidUinit(obj.regadd.unit.value);
    //@ts-ignore
    const basic =
      isValidDayOfBirth(obj.dob.value) &&
      obj.name.value &&
      obj.sex.desc &&
      checkNric;

    return !isChild ? address && basic : basic;
  }

  function onChangeData(
    e: React.ChangeEvent<HTMLInputElement>,
    childIndex: number | null = null
  ) {
    setProfileData((prev: any) => {
      const newProfileData = { ...prev };
      let currentProfile: any = newProfileData.person;
      if (childIndex) {
        currentProfile = currentProfile.childrenbirthrecords[childIndex - 1];
      }
      switch (e.target.name) {
        case "uinfin":
          currentProfile.uinfin.value = e.target.value;
          break;
        case "birthcertno":
          currentProfile.birthcertno.value = e.target.value;
          break;
        case "name":
          currentProfile.name.value = e.target.value;
          break;
        case "sex":
          currentProfile.sex.code = e.target.value;
          currentProfile.sex.desc = e.target.value === "M" ? "MALE" : "FEMALE";
          break;
        case "dob":
          currentProfile.dob.value = e.target.value;
          break;
        case "email":
          currentProfile.email.value = e.target.value;
          break;
        case "mobileno":
          currentProfile.mobileno.nbr.value = e.target.value;
          break;
        case "residentialstatus":
          currentProfile.residentialstatus.desc = e.target.value;
          break;
        case "regadd":
          currentProfile.regadd = e.target.value;
      }
      return newProfileData;
    });
  }
  async function onSubmitManualData() {
   
    let transaction_id;
    if (!transactionId) {
      transaction_id = crypto.randomUUID();
      dispatch(updateTransactionId(transaction_id));
    } else {
      transaction_id = transactionId;
    }
    let payloadToSend = profileData;
    const { day, month, year } = payloadToSend.person.dob.value;
    payloadToSend.person.dob.value = `${year}-${month}-${day}`;

    if (isChild) {
      payloadToSend.person.childrenbirthrecords.forEach((child: any) => {
        const { day, month, year } = child.dob.value;
        child.dob.value = `${year}-${month}-${day}`;
      });
    }
    let validatePayloadPersonalInfo: boolean = validationObj(
      payloadToSend.person,
      false
    );
    let validatePayloadChildInfo: boolean =
      payloadToSend.person.childrenbirthrecords.every((child: any) => {
        return validationObj(child, true);
      });
    if (!validatePayloadPersonalInfo || !validatePayloadChildInfo) {
      setGlobalErrorMsg(true);
      if (topreference.current?.scrollIntoView) {
        topreference.current.scrollIntoView({
          block: "start",
          behavior: "smooth",
          inline: "nearest",
        });
      }
      return;
    } else {
      const personType = isChild ? "child" : "myself";
      payloadToSend = {
        myinfoResponse: payloadToSend,
        insuredType: personType,
        transactionId: transaction_id,
        productCode:
          selectedPolicy === SHIELD_STARTER_HELTH_PLUS ? "NP5C" : "MSI5",
      };
    }
    try {
      const { data } = await postManualSingpass(payloadToSend);
      if (isChild) {
        dispatch(updatePersonalChildInfo(data));
      }
      dispatch(updatePersonalInfo({ ...data.myselfData, ...data.error }));
      dispatch(updateTransactionId(transaction_id));
      dispatch(updateReadyToGoNext(true));
      history.replace(
        `${ROUTE_PATH.SHIELD_STARTER_MY_INFO}?manual_data=available`
      );
    } catch {
      history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
    }
  }

  return (
    <>
      <Modal
        show={isShowModal}
        onClose={() => {
          setIsHowModal(false);
        }}
      >
        <div ref={topreference}>
          <ManualData
            onChangeData={onChangeData}
            profileData={profileData.person}
            globalErrorMsg={globalErrorMsg}
          />
          {isChild && (
            <>
              <Heading margin="40px 0px 0px 5px" variant="label">
                <b>Number of Child</b>
              </Heading>
              <Dropdown
                source={childCountDropDown}
                bindLabel="description"
                bindId="code"
                name="childcount"
                onChange={updateChild}
                placeholder="Please select childcount"
              />
              {profileData.person.childrenbirthrecords.map(
                (child: any, index: number) => {
                  return (
                    <>
                      <Labels>
                        {" "}
                        <b>Child - {index + 1}</b>
                      </Labels>
                      <ManualData
                        onChangeData={onChangeData}
                        childDataIndex={index + 1}
                        key={index}
                        profileData={child}
                      />
                    </>
                  );
                }
              )}
            </>
          )}
          <Button label="Add the data" onClick={onSubmitManualData} />
        </div>
      </Modal>
    </>
  );
}

function ManualData({
  profileData,
  onChangeData,
  childDataIndex,
  globalErrorMsg,
}: any) {
  const nationlaities = useAvivaSelector(
    (state) => state.staticData.nationlaities
  );
  const [error, setError] = useState({ email: false, mobileno: false });
  function validateAndUpdate(e: React.ChangeEvent<HTMLInputElement>) {
    switch (e.target.name) {
      case "email": {
        setError((p) => ({
          ...p,
          [e.target.name]: !Validations.isValidEmail(e.target.value),
        }));

        break;
      }
      case "mobileno": {
        setError((p) => ({
          ...p,
          [e.target.name]: !Validations.isValidPhoneNumber(e.target.value),
        }));

        break;
      }
    }
    if (onChangeData) onChangeData(e, childDataIndex);
  }
  return (
    <>
      {childDataIndex === undefined && (
        <Heading variant={"sub"}>Add MyInfo</Heading>
      )}
      {globalErrorMsg && (
        <Bullet variant="error">Enter all the required feilds</Bullet>
      )}
      <Labels>
        {childDataIndex === undefined ? "NRIC*" : "Birth Cert No.*"}
      </Labels>
      <Input
        margin="0 0 10px"
        name={childDataIndex === undefined ? "uinfin" : "birthcertno"}
        type="normal"
        maxLength={24}
        value={
          childDataIndex === undefined
            ? profileData?.uinfin?.value
            : profileData?.birthcertno?.value
        }
        onChange={validateAndUpdate}
      ></Input>
      {/* fullName */}
      <Labels>Full Name*</Labels>
      <Input
        margin="0 0 10px"
        name="name"
        maxLength={70}
        pattern=""
        value={profileData?.name?.value}
        onChange={validateAndUpdate}
      ></Input>
      {/* Gender */}
      <RadioButtonGroup
        value={profileData.sex.code}
        margin="0 0 10px"
        name="sex"
        onChange={validateAndUpdate}
      >
        <RadioButton text="Male" value="M" />
        <RadioButton text="Female" value="F" />
      </RadioButtonGroup>
      {/* Date of Birth */}
      <Labels>Date of birth*</Labels>
      <DayOfBirth
        name="dob"
        value={profileData?.dob?.value}
        onChange={validateAndUpdate}
      />
      {/* nationality */}
      {childDataIndex === undefined && (
        <>
          {" "}
          <Labels>Nationality*</Labels>
          <Dropdown
            source={nationlaities}
            bindLabel="description"
            bindId="code"
            name="nationality"
            onChange={validateAndUpdate}
            placeholder="Please select nationality"
          />
        </>
      )}
      {/* Mobile Number Optional */}
      {childDataIndex === undefined && (
        <>
          <Labels>Residential Status</Labels>
          <Input
            margin="0 0 10px"
            name="residentialstatus"
            maxLength={8}
            value={profileData.residentialstatus?.desc}
            onChange={validateAndUpdate}
          ></Input>
          <Labels>Mobile Number</Labels>
          <Input
            margin="0 0 10px"
            name="mobileno"
            maxLength={8}
            value={profileData?.mobileno?.nbr?.value}
            onChange={validateAndUpdate}
          ></Input>
          {error.mobileno && (
            <Bullet variant="error">Enter valid phone number</Bullet>
          )}
          {/* Email Id optional */}
          <Labels>Email</Labels>
          <Input
            margin="0 0 10px"
            name="email"
            maxLength={50}
            value={profileData?.email?.value}
            onChange={validateAndUpdate}
          ></Input>
          {error?.email && <Bullet variant="error">Enter valid email</Bullet>}
          {/* Address */}
          <AddressBlock onChangeData={validateAndUpdate} />
        </>
      )}
    </>
  );
}
function AddressBlock({ onChangeData }: { onChangeData: any }) {
  const [address, setAddress] = useState({
    country: { code: "SG", desc: "SINGAPORE" },
    unit: { value: "" },
    street: { value: "" },
    lastupdated: "2023-03-16",
    block: { value: "" },
    source: "1",
    postal: { value: "" },
    classification: "C",
    floor: { value: "" },
    type: "SG",
    building: { value: "" },
  });

  const [addressError, setAddressError] = useState({
    unitNo: false,
  });

  function onChange(e: ChangeEvent<HTMLInputElement>) {
    setAddress((prev) => ({
      ...prev,
      [e.target.name]: { value: e.target.value },
    }));
    const nextData = { ...address, [e.target.name]: { value: e.target.value } };
    onChangeData({
      ...e,
      target: { ...e.target, name: "regadd", value: nextData },
    });
    if (e.target.name === "unit") {
      if (!Validations.isValidUinit(e.target.value) && e.target.value) {
        setAddressError((prev) => ({
          ...prev,
          unitNo: true,
        }));
      } else {
        setAddressError((prev) => ({
          ...prev,
          unitNo: false,
        }));
      }
    }
  }

  return (
    <>
      <Labels>Postcode*</Labels>
      <Input
        margin="0 0 10px"
        name="postal"
        type="numeric"
        maxLength={6}
        value={address?.postal?.value}
        onChange={onChange}
      ></Input>

      <Labels>Block*</Labels>
      <Input
        margin="0 0 10px"
        name="block"
        value={address?.block?.value}
        maxLength={30}
        onChange={onChange}
      ></Input>

      <Labels>Unit*</Labels>
      <Input
        margin="0 0 10px"
        name="unit"
        value={address?.unit?.value}
        maxLength={30}
        placeholder="e.g. #12-456"
        onChange={onChange}
      ></Input>
      {addressError.unitNo && (
        <Bullet variant="error">
          Enter valid Unit no. e.g. #12-456, 0, 00-00
        </Bullet>
      )}
      <Labels>Street name*</Labels>
      <Input
        margin="0 0 10px"
        name="street"
        value={address?.street?.value}
        maxLength={30}
        onChange={onChange}
      ></Input>

      <Labels>Building name(if any)</Labels>
      <Input
        margin="0 0 10px"
        name="building"
        value={address?.building?.value}
        maxLength={30}
        onChange={onChange}
      ></Input>
    </>
  );
}
